import { render, staticRenderFns } from "./main.vue?vue&type=template&id=db689bc0&"
import script from "./main.js?vue&type=script&lang=js&"
export * from "./main.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports